import React from 'react';
import { useHistory } from 'react-router-dom';
import BackButton from 'components/BackButton';

const BaseAuthPage = ({ children }) => {
  const history = useHistory();

  return (
    <>
      <BackButton onEnter={history.goBack} />
      <div>{children}</div>
    </>
  );
};

export default BaseAuthPage;
